import request from '@/utils/http.js';

// 获取播放器配置项
const getPlayerConfig = (params = {}) => {
  return request({
    url: '/v3/interacts/union/player-config',
    method: 'POST',
    data: params
  });
};

// 智能字幕-信息查询
const getPlayerSubtitlesInfo = params => {
  return request('/v3/ai/video/subtitles-info', {
    method: 'GET',
    params
  });
};


export default {
  getPlayerConfig,
  getPlayerSubtitlesInfo
};
